import { memo } from "react";
import PropTypes from "prop-types";
import { BADGE_DEFAULT_COLORS } from "app/constants";
import classNames from "classnames";
import "./ColoredProductBadge.scss";
import { isEmpty } from "lodash";

const ColoredProductBadge = ({
	label,
	colorStyle = {
		txtColor: BADGE_DEFAULT_COLORS.TEXT,
		bgColor: BADGE_DEFAULT_COLORS.BACKGROUND,
		borderColor: BADGE_DEFAULT_COLORS.BORDER,
	},
	pictoUrl,
	className,
}) => {
	return (
		<div
			className={classNames({
				...(className && { [className]: true }),
				"colored-product-badge": true,
				"colored-product-badge--picto": pictoUrl,
			})}
			{...!isEmpty(colorStyle) && {
				style: {
					color: colorStyle.txtColor,
					backgroundColor: colorStyle.bgColor,
					border: colorStyle.borderColor && `1px solid ${colorStyle.borderColor}`,
				},
			}}
			data-testid="colored-product-badge"
		>
			{pictoUrl && typeof pictoUrl === "string" ? (
				<img src={pictoUrl} alt={label} className="colored-product-badge__img" />
			) : (
				pictoUrl
			)}
			{label && label}
		</div>
	);
};

ColoredProductBadge.propTypes = {
	className: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
	colorStyle: PropTypes.shape({
		txtColor: PropTypes.string,
		bgColor: PropTypes.string,
		borderColor: PropTypes.string,
	}),
	pictoUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default memo(ColoredProductBadge);
